import { Button } from "@/components/ui/button";
import React from "react";
import { FaFacebookF, FaViber, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import { GoLocation } from "react-icons/go";
import { GrPhone } from "react-icons/gr";
import { GrMailOption } from "react-icons/gr";
import { CiMobile3 } from "react-icons/ci";
import { BsInstagram, BsTiktok, BsTwitterX } from "react-icons/bs";
import { Paths } from "../constants/Paths";
function Footer() {
  return (
    <>
      <div className="pt-6">
        <div className="container py-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            <div className="mb-4">
              <h4 className="font-semibold mb-4">Follow us on</h4>
              <div className="flex space-x-2">
                <Button size="icon" variant="outline" className="rounded-full" >
                  <a target="_bank" href="https://www.facebook.com/profile.php?id=61575263924506">
                    <FaFacebookF />
                  </a>
                </Button>
                <Button size="icon" variant="outline" className="rounded-full">
                  <a target="_bank" href='https://www.tiktok.com/@yatratickets?_r=1&_t=ZS-91JU2iov7dR'>
                    <BsTiktok />
                  </a>
                </Button>
                <Button size="icon" variant="outline" className="rounded-full">
                  <a target="_bank" href='https://www.instagram.com/yatratickets/'>
                    <BsInstagram />
                  </a>
                </Button>
              </div>
            </div>
            <div className="mb-4">
              <h4 className="font-semibold mb-4">Explore</h4>
              <Link
                to="#"
                className="text-sm block hover:underline mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
              >
                International Flights
              </Link>
            </div>
            <div className="mb-4">
              <h4 className="font-semibold mb-4">Company</h4>
              <a
                href={Paths.ABOUT_US}
                className="text-sm block hover:underline mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
              >
                About
              </a>
              <a
                href={Paths.CONTACT_US}
                className="text-sm block hover:underline mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
              >
                Contact
              </a>
              <a
                href={Paths.TERMS_AND_CONDITIONS}
                className="text-sm block hover:underline mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
              >
                Terms & Conditions
              </a>
              <a
                href={Paths.PRIVACY_POLICY}
                className="text-sm block hover:underline mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
              >
                Privacy Policy
              </a>
              <a
                href={Paths.GENERAL_RULES}
                className="text-sm block hover:underline mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
              >
                Booking Rules
              </a>
            </div>
            <div className="mb-4">
              <div className="mb-3">
                <h4 className="font-semibold mb-4">Contact us</h4>
                <h4 className="font-semibold  text-sm mb-1">Address</h4>
                <p className="cursor-pointer text-sm flex items-center hover:underline mb-2 text-foreground/60 transition-colors hover:text-foreground/80">
                  <GoLocation className="me-2" />
                  5th Floor Kamaladi Complex, Kathmandu
                </p>
              </div>
              <h4 className="font-semibold  text-sm mb-1">Phone</h4>
              <div className="mb-3">
                <Link
                  to="tel:+977015971312"
                  className="text-sm flex hover:underline items-center mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
                >
                  <CiMobile3 className="me-1" />
                  01-5971312
                </Link>
                <Link
                  to="tel:+9779767996761"
                  className="text-sm flex hover:underline items-center mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
                >
                  <CiMobile3 className="me-1" />
                  (+977) 9767996761
                </Link>

                <br />
              </div>

              <h4 className="font-semibold  text-sm mb-1"> CHAT WITH US ON</h4>
              <div className="mb-3">
                <Link target="_bank"
                  to="viber://chat?number=+9779767996761"
                  className="text-sm flex hover:underline items-center mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
                >
                  <FaViber className="me-1" />
                  Viber
                </Link>
                <Link target="_blank"
                  to="https://wa.me/9779767996761?text=Hello"
                  className="text-sm flex hover:underline items-center mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
                >
                  <FaWhatsapp className="me-1" />
                  +977 9767996761
                </Link>
              </div>
              <div className="mb-3">
                <h4 className="font-semibold  text-sm mb-1">Mail</h4>
                <Link
                  to="mailto:tickets@yatratickets.com"
                  className="text-sm flex items-center hover:underline mb-2 text-foreground/60 transition-colors hover:text-foreground/80"
                >
                  <GrMailOption className="me-1" />
                  tickets@yatratickets.com
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="container py-3 border-t text-center">
          <p className="text-sm text-foreground/60">
            © YatraTickets {new Date().getFullYear()} All Rights Reserved.
          </p>
        </div>
      </div >
    </>
  );
}

export default Footer;
